import { Inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { AuthService } from './auth.service';
import { ConnectionLostService } from '../../pages/secure/home/services/connection-lost.service';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ErrorHandlerInterface } from './errors/error-handler.interface';
import { AuthorizationHandlerService } from './errors/authorization-error-handler.service';
import { GenericErrorHandlerService } from './errors/generic-error-handler.service';
import { UserErrorHandlerService } from './errors/user-error-handler.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isGuidRegexExp: RegExp;
  private GUID_REGEXP =
    '^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$';
  private anonymousApiUrlKeyword = 'anonymous';
  private handlers: ErrorHandlerInterface[] = [];

  constructor(
    private auth: AuthService,
    private connectionService: ConnectionLostService,
    private router: Router,
    private toastService: ToastrService,
    private translateService: TranslateService,
    private authorizationHandler: AuthorizationHandlerService,
    private genericHandler: GenericErrorHandlerService,
    private userHandler: UserErrorHandlerService,
  ) {
    this.isGuidRegexExp = new RegExp(this.GUID_REGEXP, 'i');
    this.handlers = [genericHandler, userHandler];
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (this.isOutsideAppContext(request)) {
      request = request.clone({
        headers: this.auth.getBearerRequestHeadersAnonymous(),
      });
    } else {
      request = request.clone({
        headers: this.auth.getBearerRequestHeaders(),
      });
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse) {
          for (const errorHandler of this.handlers) {
            if (errorHandler.handleError(error)) {
              return of<HttpEvent<any>>();
            }
          }
        }
        throw error;
      }),
    );
  }

  private isOutsideAppContext(request: HttpRequest<any>): boolean {
    return (
      this.router.url.indexOf('register') !== -1 ||
      (this.router.url.indexOf('reset-password') !== -1 &&
        !this.isGuidRegexExp.test(this.router.url.substr(16))) ||
      (this.router.url.indexOf('login') !== -1 &&
        request.url.indexOf(this.anonymousApiUrlKeyword) !== -1)
    );
  }
}
